<template>
  <b-modal modal-class="video-modal" :id="dataId" centered size="xl" hide-footer>
    <template #modal-header-close>
      <font-awesome-icon class="fa-fw" :icon="['fas', 'times']"/>
    </template>
    <div v-if="dataSrc" class="d-flex">
      <video controls autoplay>
        <source :src="dataSrc" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'videoModal',
  props: {
    dataSrc: String,
    dataId: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
